.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.footer {
  display: flex;
  justify-content: flex-end;
}

.muted {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.sectionTitle {
  margin: 0 0 var(--space-3);
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
}

/* ------------------------------------------------------------- summary */
.summary {
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-sunken);
}

.planLine {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.planName {
  font-weight: var(--weight-semibold);
}

/* Four counters that must stay on one line at dialog width, and wrap rather
   than squash on a narrow window. */
.stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-3);
}

@media (max-width: 560px) {
  .stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.statLabel {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.statValue {
  font-size: var(--text-lg);
  font-variant-numeric: tabular-nums;
}

/* "Remaining" is the number the admin came here to read. */
.statValueStrong {
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  font-variant-numeric: tabular-nums;
}

.meta {
  margin: var(--space-4) 0 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

/* ----------------------------------------------------------- adjust row */
.adjust {
  padding-top: var(--space-1);
}

/* Sessions / reason / button. The button aligns to the field baseline, not
   the label, hence the bottom alignment. */
.adjustRow {
  display: grid;
  grid-template-columns: 110px 1fr auto;
  gap: var(--space-3);
  align-items: end;
}

@media (max-width: 560px) {
  .adjustRow {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
}

/* ---------------------------------------------------------------- assign */
.assign {
  padding-top: var(--space-1);
}

.assignRow {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--space-3);
  align-items: end;
  margin-top: var(--space-3);
}

@media (max-width: 560px) {
  .assignRow {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
}

/* ---------------------------------------------------------------- ledger */
.ledger {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  /* Long histories scroll inside the dialog rather than pushing the assign
     controls out of reach. */
  max-height: 260px;
  overflow-y: auto;
}

.entry {
  display: grid;
  grid-template-columns: 92px 1fr 48px 96px;
  gap: var(--space-3);
  align-items: baseline;
  padding: var(--space-3) var(--space-4);
  font-size: var(--text-sm);
}

.entry + .entry {
  border-top: 1px solid var(--border);
}

@media (max-width: 560px) {
  .entry {
    grid-template-columns: 1fr auto;
  }

  .entryDate {
    grid-column: 1 / -1;
  }
}

.entryType {
  font-weight: var(--weight-medium);
}

.entryReason {
  color: var(--text-muted);
  overflow-wrap: anywhere;
}

.entryDate {
  color: var(--text-muted);
  font-size: var(--text-xs);
  text-align: right;
}

.deltaUp,
.deltaDown,
.deltaNone {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-weight: var(--weight-medium);
}

.deltaUp {
  color: var(--success);
}

.deltaDown {
  color: var(--danger);
}

.deltaNone {
  color: var(--text-muted);
}
